<template>
  <v-row class="background-color-white full-width" justify="center" no-gutters>
    <v-col
      cols="12"
      v-if="products.length"
      class="
        background-color-white
        d-flex
        flex-column
        margin-top
        no-overflow
        z-index-6
      "
      ref="searchResultsRef"
    >
      <div v-for="product in products" :key="product.id">
        <Product :product="product" />
      </div>
      <div class="mb-12 text-center">
        <v-progress-circular
          v-show="!end"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-col>
    <v-col
      v-if="empty"
      cols="12"
      class="
        align-center
        background-color-seashell
        d-flex
        font-color-black-magic font-weight-bold
        justify-center
        margin-top
        no-results
        z-index-6
      "
      >Your search did not match any products</v-col
    >
  </v-row>
</template>

<script>
import throttle from "lodash.throttle";
import { mapState } from "vuex";
import Product from "@/components/Search/Product.vue";

const getPixelsFromBottom = (searchResultsRef) => {
  if (!searchResultsRef) {
    return;
  }
  return (
    searchResultsRef.scrollHeight -
    searchResultsRef.scrollTop -
    searchResultsRef.offsetHeight
  );
};

const needMoreProducts = (searchResultsRef) => {
  const pixelsFromBottomToMakeAnotherRequest = 300;
  const pixelsFromBottom = getPixelsFromBottom(searchResultsRef);
  return pixelsFromBottom < pixelsFromBottomToMakeAnotherRequest;
};

export default {
  name: "XsSearchResults",
  components: { Product },
  computed: {
    ...mapState({
      empty: (state) => state.search.empty,
      end: (state) => state.search.end,
      products: (state) => state.search.products,
    }),
  },
  created() {
    document.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll: throttle(function () {
      const { searchResultsRef } = this.$refs;
      if (needMoreProducts(searchResultsRef)) {
        this.$store.commit("search/UPDATE_PAGE");
        this.$store.dispatch("search/fetchAndConcat");
      }
    }, 300),
  },
};
</script>

<style scoped>
.margin-top {
  /* height of search bar is 70px */
  margin-top: 70px;
}

.no-results {
  border-radius: 10px;
  height: 148px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}

.z-index-6 {
  z-index: 6;
}
</style>
